// extracted by mini-css-extract-plugin
export default {"header":"header___kn4BF","header_content":"header_content___sEHIg"};